<template>
  <div>
    <v-flex xs12>
      <v-layout column>
        <v-flex xs12 px-2 py-1 v-for="(filter, index) in filters" :key="index">
          <v-text-field
            v-if="filter.type === 'text'"
            :label="filter.label"
            v-model="filter.value"
            @input="updateFilterValue(filter, $event)"
            hide-details
          />

          <v-layout
            row
            align-center
            v-if="filter.type === 'int' || filter.type === 'float'"
          >
            <v-text-field
              :label="filter.label + ' ' + getOperationString(filter.operation)"
              v-model="filter.value"
              type="number"
              @input="updateFilterValue(filter, $event)"
              hide-details
            >
              <template v-slot:append>
                <v-btn
                  icon
                  depressed
                  small
                  color="primary"
                  @click="changeOperation(filter)"
                  >{{ filter.operation }}</v-btn
                >
              </template>
            </v-text-field>
          </v-layout>

          <v-autocomplete
            v-if="filter.type === 'resource_id'"
            :label="filter.label"
            v-model="filter.value"
            @change="updateFilterValue(filter, $event)"
            :items="getResources(filter.getter)"
            item-value="id"
            :item-text="filter.itemText ? filter.itemText : 'name'"
            background-color="white"
            browser-autocomplete="noautocomplete"
            hide-details
            clearable
            dense
          />
          <!-- removed reconciliated from the loop, now ahead in toolbar -->

          <v-autocomplete
            dense
            v-if="filter.type === 'enum'"
            :label="filter.label"
            v-model="filter.value"
            @change="updateFilterValue(filter, $event)"
            :items="filter.resources"
            item-value="value"
            item-text="text"
            background-color="white"
            browser-autocomplete="noautocomplete"
            hide-details
            clearable
          />

          <date-field
            v-if="filter.type === 'date'"
            :label="filter.label"
            v-model="filter.value"
            :currentDate="filter.value"
            @input="updateFilterValue(filter, $event)"
          />
        </v-flex>

        <v-flex xs12 pt-2 pr-1>
          <v-btn
            block
            small
            :flat="currentFilterStr == ''"
            color="error"
            @click="reset"
            :disabled="currentFilterStr == ''"
          >
            <v-icon small class="pr-2">cached</v-icon>Reset filters
          </v-btn>
          <div style="display: none;">
            <!-- TODO.
            Find less hacky way to force filter.value to update
            when clicking on refresh button U_U
            Maybe don't use nested props field as value field
            -->
            {{ currentFilterStr }}
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
</template>
<script>
import dateField from "./dateField";

export default {
  name: "filtersGenerator",
  components: { dateField },
  props: {
    /*  Filter array exemple :
      [
        {
          field: "name",
          label: "Name",
          type: "text"
        },
        {
          field: "company_id",
          label: "Customer",
          type: "resource_id",
          itemText: "name"          <- this field will be used to display resource in v-autocomplete
          getter: "customers"       <- will be loaded from commonStore
        },
        {
          field: "amount",
          label: "Amount",
          type: float,
          operation: ">="             <- Should be present into numberOperations
        },
        {
          field: "operation_type",
          label: "Operation Type",
          type: "enum",
          resources: [
            {text: "All", value:""},
            {text: "Invoice", value:"credit"},
            {text: "Credit Note", value: "debit"}
          ]
        },
        {
          field: "expected_payment_date",
          label: "Expected Payment Before",
          type: "date",
          operation: "<"
        }
      ]
    */
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected_subsidiary_tab: 0,
      selected_currency_tab: 0,
      open: true,
      expand: true,
      numberOperations: [">=", "<=", "==", "<", ">"],
      defaultDate: new Date().toISOString().substr(0, 10),
      currentFilterStr: "",
    };
  },
  methods: {
    updateFilterValue(filter, value) {
      if (filter) filter.value = value;
      this.buildAndEmitFilters();
    },
    getFilterStr(field, value, type, operation) {
      if (type === "text") {
        return value ? `${field} like '%${value}%'` : "";
      } else if (type === "resource_id") {
        return value ? `${field} === '${value}'` : "";
      } else if (type === "float" || type === "int") {
        return value ? `${field} ${operation} '${value}'` : "";
      } else if (type === "enum") {
        return value ? `${field} === ${value}` : "";
      } else if (type === "date") {
        return value ? `${field} ${operation} '${value}'` : "";
      }
    },
    buildAndEmitFilters() {
      var filter = {};
      var ret = [];
      for (var i = 0; i < this.filters.length; i++) {
        filter = this.filters[i];
        ret.push(
          this.getFilterStr(
            filter.field,
            filter.value,
            filter.type,
            filter.operation
          )
        );
      }
      var newFilterStr = ret.filter((e) => e).join(" && ");
      /*
        Keep the last sended filter string in memory,
        thus don't send it if there is no changes
      */
      if (this.currentFilterStr != newFilterStr) {
        this.currentFilterStr = newFilterStr;
        this.$emit("newFiltersValue", newFilterStr);
      }
    },
    changeOperation(filter) {
      var cur = this.numberOperations.indexOf(filter.operation);
      var n = (cur + 1) % this.numberOperations.length;
      filter.operation = this.numberOperations[n];
      this.buildAndEmitFilters();
    },
    getOperationString(operation) {
      switch (operation) {
        case "==":
          return "equal to";
        case ">=":
          return "greater or equal to";
        case "<=":
          return "smaller or equal to";
        case ">":
          return "greater than";
        case "<":
          return "smaller than";
        default:
          return "";
      }
    },
    getResources(getter) {
      return this.$store.getters[`commonStore/${getter}`];
    },
    reset() {
      for (var i = 0; i < this.filters.length; i++) {
        this.filters[i].value = "";
      }
      this.buildAndEmitFilters();
    },
  },
  created() {
    var filter;
    for (var i = 0; i < this.filters.length; i++) {
      filter = this.filters[i];
      filter.value = "";
      if (filter.field in this.$route.query) {
        filter.value = this.$route.query[filter.field];
      } else if (filter.field in this.$route.params) {
        filter.value = this.$route.params[filter.field];
      }
    }
    this.buildAndEmitFilters();
  },
};
</script>
